import {Row, Col, Table, Button, Modal, Form} from 'react-bootstrap';
import { MapContainer, TileLayer, useMap, Marker, Popup } from 'react-leaflet'
import {PencilSquare, Trash3, CheckCircle } from 'react-bootstrap-icons';
import {useState, useEffect, useRef} from 'react';
import { useSelector } from 'react-redux';
import { useUpdateSiteMutation } from '../../slices/sitesApiSlice';
import { useUpdateDeviceMutation } from '../../slices/devicesApiSlice';
import { useCreateNoteMutation, useUpdateNoteMutation, useDeleteNoteMutation} from '../../slices/notesApiSlice'
import { useCreateTaskMutation, useUpdateTaskMutation, useDeleteTaskMutation, useMarkCompleteMutation} from '../../slices/tasksApiSlice'
import { toast } from 'react-toastify';

const SiteDetails = ({siteInfo, isps, siteNotes, siteTasks}) => {
    const {userInfo} = useSelector((state) => state.auth);

    const newNote = {
        content: '',
        site: siteInfo._id,
        user: {
            _id: userInfo._id,
            name: userInfo.name
        }
    }

    const newTask = {
        content: '',
        status: 'inprogress',
        assigned_to: '',
        priority: '',
        site: siteInfo._id,
        user: {
            _id: userInfo._id,
            name: userInfo.name
        }
    }

    const [incSite, setIncSite] = useState({
        name: "",
        abbr: "",
        company: "",
        locationAddress: {
            address: "",
            city: "",
            state: "",
            postalCode: ""
        },
        phoneNumber: "",
        contactName: "",
        contactNum: "",
        ipRange: "",
        ipRanges: [
            {
                name: "",
                range: "",
            }
        ],
        mainFirewallIP: "",
        BGP: "",
        AS: "",
        DattoUID: "",
        lat: "",
        lng: "",
        files: [
            {
                name:"",
                path:""
            }
        ],
        images:[
            {
                name: "",
                path:""
            }
        ]

    })

    const [incISP, setIncISP] = useState({
        name: "",
        companyName: "",
        supportNumber: "",
        connType: "",
        wanIP: "",
        acctNum: "",
        site: siteInfo._id,
        type: "ISP",
    })


    const [updateDevice] = useUpdateDeviceMutation();
    const [updateSite, {isLoading, error}] = useUpdateSiteMutation();

    const[site, setSite] = useState(siteInfo);
    const[isp, setIsp] = useState(isps);
    const siteRef = useRef();
    siteRef.current = site;
    const incSiteRef = useRef();
    incSiteRef.current = incSite;

    const [showInfo, setShowInfo] = useState(false);
    const [showISP, setShowISP] = useState(false);
    const [showNote, setShowNote] = useState(false);
    const [showTask, setShowTask] = useState(false);
    const [showTaskComplete, setShowTaskComplete] = useState(false);
    const [showErrorNote, setShowErrorNote] = useState(false);
    const [showErrorTask, setShowErrorTask] = useState(false);
    const [showErrorInfo, setShowErrorInfo] = useState(false);

    const [createNote] = useCreateNoteMutation();
    const [updateNote] = useUpdateNoteMutation();
    const [deleteNote] = useDeleteNoteMutation();
    const [notes, setNotes] = useState(siteNotes);
    const [note, setNote] = useState(newNote);
    const noteRef = useRef();
    noteRef.current = note;

    const[submitAction, setSubmitAction] = useState();
    const[submitActionTask, setSubmitActionTask] = useState();
    const [createTask] = useCreateTaskMutation();
    const [updateTask] = useUpdateTaskMutation();
    const [deleteTask] = useDeleteTaskMutation();
    const [markComplete]  = useMarkCompleteMutation();
    const [tasks, setTasks] = useState(siteTasks);
    const [task, setTask] = useState(newTask);
    const taskRef = useRef();
    taskRef.current = task;
    
    
    useEffect(() => {
        if(site){
            setSite(site);
        }
    }, [site])

    useEffect(() => {
        if(isp){
            setIsp(isp);
        }
    }, [isp])
    useEffect(() => {
        if(incSite){
            setIncSite(incSite);
        }
    }, [incSite])

    useEffect(() => {
        if(incISP){
            setIncISP(incISP);
        }
    }, [incISP])

    useEffect(() => {
        if(notes){
            setNotes(notes);
            
        }
    }, [notes])

    useEffect(() => {
        if(tasks){
            setTasks(tasks);
            
        }
    }, [tasks])

    const handleCloseErrorInfo = () => {
        setShowErrorInfo(false);
    }
       
    const handleCloseInfo = () => {
        setShowInfo(false);
    }
    const handleShowInfo = (e) => {
        setIncSite(site);
        setShowInfo(true);
    }

    const handleCloseISP = () => {
        setShowISP(false);
    }
    const handleShowISP = (ispID) => {
        
        isp.map(is => {
        
            if(is._id === ispID){
                setIncISP(is);
                setShowISP(true);
            }
           })
    }


    const createNoteHandler = async () => {
        setShowNote(false);
        const currNote = noteRef.current;
        try{
            
            const res = await createNote(currNote).unwrap();
            toast.success(res.message);
    
            setNotes([...notes, res.addedNote[0]])
            setNote(newNote);
        }catch (error){
            toast.error(error?.data?.message || error.error);
        }
    }

    const editNoteHandler = (noteId) => {
       notes.map(n => {
        if(n._id === noteId){
            setNote(n);
            setSubmitAction(() => updateNoteHandler)
            setShowNote(true);
        }
       })
    }

    const updateNoteHandler = async () => {
        const currNote = noteRef.current;
        const updatedNotes = []
        const res = await updateNote(currNote).unwrap();
        notes.map(n => {
            if(n._id == res.updatedNote._id){
                updatedNotes.push(res.updatedNote)
            } else {
                updatedNotes.push(n);
            }
        });
        setNotes(updatedNotes);
        setShowNote(false);
        toast.success(res.message);
    }




    const handleShowNote = (e) => {
        setSubmitAction(() => createNoteHandler);
        setShowNote(true);
    }

    const handleCloseNote = () => {
        setShowNote(false);
    }

    

    const onChangeNote = event => {
        const {name, value} = event.target;
        setNote(prevState => ({
            ...prevState,
            [name]:value
        }));
    }


    const handleCloseErrorNote = () => {
        setShowErrorNote(false);
        setNote(newNote);
    }

    const deleteNoteHandler = (noteId) => {
        notes.map(n => {
            if(n._id === noteId){
                setNote(n);
                setShowErrorNote(true);
            }
           })
    }

    const removeNoteHandler = async () => {
        const currNote = noteRef.current;
        const res = await deleteNote(currNote._id).unwrap();
        const index = notes.findIndex(n => n._id === currNote._id);
        if (index !== -1) {
          const newArray = [...notes.slice(0, index), ...notes.slice(index + 1)];
          setNotes(newArray);
        }
        setShowErrorNote(false);
        setNote(newNote);
        toast.success(res.message);
    }


    const createTaskHandler = async () => {
        setShowTask(false);
        const currTask = taskRef.current;
        try{
            const res = await createTask(currTask).unwrap();
            toast.success(res.message);
            setTasks([...tasks, res.addedTask[0]])
            setTask(newTask);
        }catch (error){
            toast.error(error?.data?.message || error.error);
        }
    }

    const editTaskHandler = (taskId) => {
       tasks.map(t => {
        if(t._id === taskId){
            setTask(t);
            setSubmitActionTask(() => updateTaskHandler)
            setShowTask(true);
        }
       })
    }

    const updateTaskHandler = async () => {
        const currTask = taskRef.current;
        const updatedTasks = []
        const res = await updateTask(currTask).unwrap();
        tasks.map(t => {
            if(t._id == res.updatedTask._id){
                updatedTasks.push(res.updatedTask)
            } else {
                updatedTasks.push(t);
            }
        });
        setTasks(updatedTasks);
        setShowTask(false);
        toast.success(res.message);
    }



    const completeTaskHandler = (taskId) => {
        tasks.map(t => {
         if(t._id === taskId){
             setTask(t);
             setShowTaskComplete(true);
         }
        })
     }

     const handleShowComplete = (e) => {
        setShowTaskComplete(true);
    }

    const handleCloseComplete = () => {
        setShowTaskComplete(false);
    }


    const submitTaskComplete = async () => {
        const currTask = taskRef.current;
       
        const updatedTasks = []
        const res = await markComplete(currTask).unwrap();
        const index = tasks.findIndex(t => t._id === currTask._id);
        if (index !== -1) {
          const newArray = [...tasks.slice(0, index), ...tasks.slice(index + 1)];
          setTasks(newArray);
        }
        setShowTaskComplete(false);
        toast.success(res.message);
    }







    const handleShowTask = (e) => {
        setSubmitActionTask(() => createTaskHandler);
        setShowTask(true);
    }

    const handleCloseTask = () => {
        setShowTask(false);
    }


    const onChangeTask = event => {
        const {name, value} = event.target;
        setTask(prevState => ({
            ...prevState,
            [name]:value
        }));
    }

    const handleCloseErrorTask = () => {
        setShowErrorTask(false);
        setTask(newTask);
    }

    const deleteTaskHandler = (taskId) => {
        tasks.map(t => {
            if(t._id === taskId){
                setTask(t);
                setShowErrorTask(true);
            }
           })
    }

    const removeTaskHandler = async () => {
        const currTask = taskRef.current;
        const res = await deleteTask(currTask._id).unwrap();
        const index = tasks.findIndex(t => t._id === currTask._id);
        if (index !== -1) {
          const newArray = [...tasks.slice(0, index), ...tasks.slice(index + 1)];
          setTasks(newArray);
        }
        setShowErrorTask(false);
        setTask(newTask);
        toast.success(res.message);
    }


    const onChangeISP =  event => {
        const {name, value} = event.target;
        setIncISP(incISP => ({
            ...incISP,
            [name]:value
        }));
    }

    const updateISPHandler = async () => {
        const updatedISPs = []
        const res = await updateDevice(incISP).unwrap();
        isp.map(is => {
            if(is._id == res.updatedDevice._id){
                updatedISPs.push(res.updatedDevice)
            } else {
                updatedISPs.push(is);
            }
        });
        
        setIsp(updatedISPs);
        setShowISP(false);
        toast.success(res.message);
    }


    const onChange = (level, rangeId) => event => {
        const {name, value} = event.target;
       
        if(!level){
            setIncSite(site => ({
                ...site,
                [name]:value
            }));
        } else {
            if(!rangeId){
               
                setIncSite({
                    ...site,
                    [level]:{
                        ...site[level],
                        [name]:value
                    }
                })
            } else {
                const newIpRanges = [...incSite.ipRanges];
               
                let index = newIpRanges.findIndex(s => s._id == rangeId);

                if(index != -1){
                    newIpRanges[index] = {
                      ...newIpRanges[index], //keeping existing values in object
                      [name]: value  //here property can be "price" or "description"
                    }
                 }

                setIncSite({...incSite, ipRanges: newIpRanges});
            }
        }
        
    }

    const updateSiteHandler = async () => {
        const currIncSite = incSiteRef.current;
        const currSite = siteRef.current;
        const res = await updateSite(currIncSite).unwrap();
        setSite(res.updatedSite);
        setShowInfo(false);
        toast.success(res.message);
    }


 

    return  isLoading ? (
        <h2>Loading</h2>
    ): error ? (
        <div>{error?.data?.message || error.error}</div>
    ) : (
        <>




             <Modal show={showErrorNote} onHide={handleCloseErrorNote} centered>
                <Modal.Header closeButton>
                <Modal.Title>Delete Note</Modal.Title>
                </Modal.Header>
                <Modal.Body>Are you sure you want to delete this note?</Modal.Body>
                <Modal.Footer>
                <Button variant="secondary" onClick={handleCloseErrorNote}>
                    Close
                </Button>
                <Button variant="danger" onClick={removeNoteHandler}>
                    Delete
                </Button>
                </Modal.Footer>
            </Modal>


            <Modal show={showErrorTask} onHide={handleCloseErrorTask} centered>
                <Modal.Header closeButton>
                <Modal.Title>Delete Task</Modal.Title>
                </Modal.Header>
                <Modal.Body>Are you sure you want to delete this task?</Modal.Body>
                <Modal.Footer>
                <Button variant="secondary" onClick={handleCloseErrorTask}>
                    Close
                </Button>
                <Button variant="danger" onClick={removeTaskHandler}>
                    Delete
                </Button>
                </Modal.Footer>
            </Modal>







        <Modal show={showInfo} onHide={handleCloseInfo} centered>
            <Modal.Header closeButton>
                <Modal.Title>Edit Site</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Row>
                        <Col>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>Name</Form.Label>
                            <Form.Control 
                                name="name"
                                value={incSite.name}
                                onChange={onChange()}
                                type="text" 
                                placeholder="" 
                            />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>Company</Form.Label>
                            <Form.Control 
                                name="company"
                                value={incSite.company}
                                onChange={onChange()}
                                type="text" 
                                placeholder="" 
                            />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>Address 1</Form.Label>
                            <Form.Control 
                                name="address"
                                value={incSite.locationAddress.address}
                                onChange={onChange('locationAddress')}
                                type="text" 
                                placeholder="" 
                            />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>City</Form.Label>
                            <Form.Control 
                                name="city"
                                value={incSite.locationAddress.city}
                                onChange={onChange('locationAddress')}
                                type="text" 
                                placeholder="" 
                            />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>State</Form.Label>
                            <Form.Control 
                                name="state"
                                value={incSite.locationAddress.state}
                                onChange={onChange('locationAddress')}
                                type="text" 
                                placeholder="" 
                            />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>Postal Code</Form.Label>
                            <Form.Control 
                                name="postalCode"
                                value={incSite.locationAddress.postalCode}
                                onChange={onChange('locationAddress')}
                                type="text" 
                                placeholder="" 
                            />
                        </Form.Group>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>Phone Number</Form.Label>
                                <Form.Control 
                                    name="phoneNumber"
                                    value={incSite.phoneNumber}
                                    onChange={onChange()}
                                    type="text" 
                                    placeholder="" 
                                />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>Main Contact</Form.Label>
                                <Form.Control 
                                    name="contactName"
                                    value={incSite.contactName}
                                    onChange={onChange()}
                                    type="text" 
                                    placeholder="" 
                                />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>Main Contact #</Form.Label>
                                <Form.Control 
                                    name="contactNum"
                                    value={incSite.contactNum}
                                    onChange={onChange()}
                                    type="text" 
                                    placeholder="" 
                                />
                            </Form.Group>
                            </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>Firwall IP:</Form.Label>
                                <Form.Control 
                                    name="mainFirewallIP"
                                    value={incSite.mainFirewallIP}
                                    onChange={onChange()}
                                    type="text" 
                                    placeholder="" 
                                />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>IP Range:</Form.Label>
                                <Form.Control 
                                    as="textarea" 
                                    rows={3}
                                    name="ipRange"
                                    value={incSite.ipRange}
                                    onChange={onChange()}
                                    type="textarea" 
                                    placeholder="" 
                                />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>IP RANGES</Form.Label>
                                {incSite.ipRanges.map((ipRange) => (
                                    <Form.Group>
                                        <Form.Control 
                                            name="name"
                                            value={ipRange.name}
                                            onChange={onChange('name', ipRange._id)}
                                            type="text" 
                                            placeholder="" 
                                        />
                                        <Form.Control 
                                            name="range"
                                            value={ipRange.range}
                                            onChange={onChange('range', ipRange._id)}
                                            type="text" 
                                            placeholder="" 
                                        />
                                    </Form.Group>
                                ))}
                                
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>BGP:</Form.Label>
                                <Form.Control 
                                    name="BGP"
                                    value={incSite.BGP}
                                    onChange={onChange()}
                                    type="text" 
                                    placeholder="" 
                                />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>AS:</Form.Label>
                                <Form.Control 
                                    name="AS"
                                    value={incSite.AS}
                                    onChange={onChange()}
                                    type="text" 
                                    placeholder="" 
                                />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>Datto UID:</Form.Label>
                                <Form.Control 
                                    name="DattoUID"
                                    value={incSite.DattoUID || ''}
                                    onChange={onChange()}
                                    type="text" 
                                    placeholder="" 
                                />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>Lat:</Form.Label>
                                <Form.Control 
                                    name="lat"
                                    value={incSite.lat}
                                    onChange={onChange()}
                                    type="text" 
                                    placeholder="" 
                                />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>Lng:</Form.Label>
                                <Form.Control 
                                    name="lng"
                                    value={incSite.lng}
                                    onChange={onChange()}
                                    type="text" 
                                    placeholder="" 
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                  
                    
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleCloseInfo}>
                    Close
                </Button>
                <Button id='modalSubmitButton' variant="success" onClick={updateSiteHandler}>
                    Submit
                </Button>
            </Modal.Footer>
        </Modal>


        <Modal show={showISP} onHide={handleCloseISP} centered>
            <Modal.Header closeButton>
                <Modal.Title>Edit ISP Info</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label>Company</Form.Label>
                        <Form.Control 
                            name="companyName"
                            value={incISP.companyName}
                            onChange={onChangeISP}
                            type="text" 
                            placeholder="" 
                        />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label>Contact Number</Form.Label>
                        <Form.Control 
                            name="supportNumber"
                            value={incISP.supportNumber}
                            onChange={onChangeISP}
                            type="text" 
                            placeholder="" 
                        />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label>Connection Type</Form.Label>
                        <Form.Control 
                            name="connType"
                            value={incISP.connType}
                            onChange={onChangeISP}
                            type="text" 
                            placeholder="" 
                        />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label>Device</Form.Label>
                        <Form.Control 
                            name="name"
                            value={incISP.name}
                            onChange={onChangeISP}
                            type="text" 
                            placeholder="" 
                        />
                    </Form.Group>
                    
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label>WanIP</Form.Label>
                        <Form.Control 
                            name="wanIP"
                            value={incISP.wanIP}
                            onChange={onChangeISP}
                            type="text" 
                            placeholder="" 
                        />
                        </Form.Group>
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                      <Form.Label>Acct #</Form.Label>
                      <Form.Control
                          name="acctNum"
                          value={incISP.acctNum}
                          onChange={onChangeISP}
                          type="text"
                          placeholder=""
                      />
                     </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseISP}>
                        Close
                    </Button>
                    <Button id='modalSubmitButton' variant="success" onClick={updateISPHandler}>
                        Submit
                    </Button>
                </Modal.Footer>
            </Modal>


            <Modal show={showNote} onHide={handleCloseNote} centered>
            <Modal.Header closeButton>
                <Modal.Title>Add Note</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label>Note</Form.Label>
                        <Form.Control 
                            name="content"
                            value={note.content}
                            onChange={onChangeNote}
                            type="textarea" 
                            placeholder="" 
                        />
                    </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseNote}>
                        Close
                    </Button>
                    <Button id='modalSubmitButton' variant="success"  onClick={submitAction}>
                        Submit
                    </Button>
                </Modal.Footer>
            </Modal>





            <Modal show={showTask} onHide={handleCloseTask} centered>
            <Modal.Header closeButton>
                <Modal.Title>Add Task</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group className="mb-3" controlId="taskContent">
                        <Form.Label>Task</Form.Label>
                        <Form.Control 
                            as="textarea"
                            rows={3}
                            name="content"
                            value={task.content}
                            onChange={onChangeTask}
                            placeholder="Describe the task..." 
                        />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="taskAssignedTo">
                        <Form.Label>Assigned To</Form.Label>
                        <Form.Control 
                            name="assigned_to"
                            value={task.assigned_to}
                            onChange={onChangeTask}
                            type="text" 
                            placeholder="" 
                        />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="taskPriority">
                        <Form.Label>Priority</Form.Label>
                        <Form.Select 
                            name="priority"
                            value={task.priority}
                            onChange={onChangeTask}
                        >
                            <option value="">Select Priority...</option>
                            <option value="Low">Low</option>
                            <option value="Medium">Medium</option>
                            <option value="High">High</option>
                        </Form.Select>
                    </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseTask}>
                        Close
                    </Button>
                    <Button id='modalSubmitButton' variant="success"  onClick={submitActionTask}>
                        Submit
                    </Button>
                </Modal.Footer>
            </Modal>



            <Modal show={showTaskComplete} onHide={handleCloseComplete} centered>
            <Modal.Header closeButton>
                <Modal.Title>Mark Task Complete?</Modal.Title>
            </Modal.Header>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseComplete}>
                        Close
                    </Button>
                    <Button id='modalSubmitButton' variant="success"  onClick={submitTaskComplete}>
                        Complete
                    </Button>
                </Modal.Footer>
            </Modal>




        <Row>
        <Col md={5}>
        <Row>
            <Col>
                <Table  bordered>
                <tr>
                    <th>Location:</th>
                    <td>{site.name} - {site.abbr}</td>
                    <td><button className='tableButton' value={site._id} onClick={() => handleShowInfo()}><PencilSquare /></button></td>
                </tr>
                <tr>
                    <th>Company:</th>
                    <td>{site.company}</td>
                    <td></td>
                </tr>
                <tr>
                    <th>Address:</th>
                    <td><a href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`${site.locationAddress.address} ${site.locationAddress.city}, ${site.locationAddress.state} ${site.locationAddress.postalCode}`)}`} target="_blank" rel="noopener noreferrer" style={{ display: 'block', color: 'var(--theme-primary)', textDecoration: 'underline' }}>{site.locationAddress.address} {site.locationAddress.city}, <br/>{site.locationAddress.state} {site.locationAddress.postalCode}</a></td>
                    <td></td>
                </tr>
                <tr>
                    <th>Phone Number:</th>
                    <td>{site.phoneNumber}</td>
                    <td></td>
                </tr>
                <tr>
                    <th>Main Contact:</th>
                    <td>{site.contactName}</td>
                    <td></td>
                </tr>
                <tr>
                    <th>Main Contact #:</th>
                    <td>{site.contactNum}</td>
                    <td></td>
                </tr> 
                </Table>
            </Col>
        </Row>
     
        <Row>
            <Col>
                <div className='colHeader'>Network Info</div>
                <Table  bordered >
                    <tr>
                        <th>Firewall IP:</th>
                        <td><a target='_blank' href={`http://${site.mainFirewallIP}`}>{site.mainFirewallIP}</a></td>
                        <td></td>
                    </tr>
                    <tr className='newLineText'>
                        <th>IP Ranges:</th>
                        <td className='newLineText'>{site.ipRange}</td>
                    </tr>
                    <tr>
                        <th>BGP:</th>
                        <td>{site.BGP}</td>
                        <td></td>
                    </tr>
                    <tr>
                        <th>AS:</th>
                        <td>{site.AS}</td>
                        <td></td>
                    </tr>
                    <tr>
                        <th>Datto UID:</th>
                        <td>{site.DattoUID}</td>
                        <td></td>
                    </tr>
                </Table>
            </Col>
        </Row>
        <Row>
            <Col >
                {isp.map((is) => (
                    <Table size='sm'>
                        <tr><thead><th>ISP</th><td><td><button className='tableButton' value={is._id} onClick={() => handleShowISP(is._id)}><PencilSquare /></button></td></td></thead></tr>
                        <tr>
                            <th>Company Name:</th>
                            <td>{is.companyName}</td>
                        </tr>
                        <tr>
                            <th>Contact Number:</th>
                            <td>{is.supportNumber}</td>
                        </tr>
                        <tr>
                            <th>Connection Type:</th>
                            <td>{is.connType}</td>
                        </tr>
                        <tr>
                            <th>Device:</th>
                            <td>{is.name}</td>
                        </tr>
                        <tr>
                            <th>WanIP:</th>
                            <td>{is.wanIP}</td>
                        </tr>
                        <tr>
                            <th>Acct #:</th>
                            <td>{is.acctNum}</td>
                        </tr>
                    </Table>
               ))}
            </Col>
        </Row>
        <Row>
                    <Col>
                        <h3>Notes</h3>
                    </Col>
                    <Col className='text-end'>
                        <Button className='btn-sm m-3' onClick={handleShowNote}>
                            Add Note
                        </Button>
                    </Col>
               </Row>
               <Row>
                <Col>
                    {notes.map((note) => (
                        <Row className='noteCard'>
                            <Col>
                                <Row>
                                    <Col>
                                        <p><span className='boldText'>Created By: </span>{note.user ? note.user.name : 'NA'}<br/><span className='boldText'>Created On: </span>{note.createdAt ? new Date(note.createdAt).toLocaleDateString() : 'NA'}</p>
                                    </Col>
                                    <Col className='text-end'>

                                    {note.user._id === userInfo._id ? <>
                                        <button className='tableButton' value={note._id} onClick={() => editNoteHandler(note._id)}><PencilSquare /></button>
                                        <button className='tableButton' value={note._id} onClick={() => deleteNoteHandler(note._id)}><Trash3 /></button>
                                        </>: <p></p>}
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <p>{note.content}</p>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    ))}
                </Col>
               </Row>

        </Col>
        
        <Col>
          <Row>
            <Col>
                <MapContainer
                    center={[site.lat, site.lng]}
                    zoom={13}
                    scrollWheelZoom={true}
                    style={{ width: "100%", height: "calc(50vh - 2rem)" }}
                    >
                    <TileLayer
                        url="http://{s}.tile.osm.org/{z}/{x}/{y}.png"
                        attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                    />
                    <Marker position={[site.lat, site.lng]}>
                        <Popup>
                        <ul>
                            <li>Site: {site.abbr}</li>
                            
                        </ul>
                        </Popup>
                    </Marker>
                </MapContainer>
            </Col>
          </Row>
          <Row>
            <Col>
               

               <Row>
                    <Col>
                        <h3>Tasks</h3>
                    </Col>
                    <Col className='text-end'>
                        <Button className='btn-sm m-3' onClick={handleShowTask}>
                            Add Task
                        </Button>
                    </Col>
               </Row>

               <Row>
                <Col>
                    {tasks.map((task) => (
                        <Row className='noteCard'>
                            <Col>
                                <Row>
                                    <Col>
                                    <p><span className='boldText'>Created By: </span>{task.user ? task.user.name : 'NA'}<br/><span className='boldText'>Created On: </span>{task.createdAt ? new Date(task.createdAt).toLocaleDateString() : 'NA'}<br/><span className='boldText'> Assigned To: </span> {task.assigned_to}<br/><span className='boldText'> Priority: </span> {task.priority}</p>
                                    </Col>
                                    <Col className='text-end'>
                                    {task.user.isAdmin ? 
                                        <button className='tableButton' value={task._id} onClick={() => completeTaskHandler(task._id)}><CheckCircle /></button>
                                    : <div></div>}
                                    {task.user._id === userInfo._id ? <>
                                        <button className='tableButton' value={task._id} onClick={() => editTaskHandler(task._id)}><PencilSquare /></button>
                                        <button className='tableButton' value={task._id} onClick={() => deleteTaskHandler(task._id)}><Trash3 /></button>
                                        </>: <p></p>}
                                    </Col> 
                                    
                                </Row>
                                <Row>
                                    <Col>
                                        <p>{task.content}</p>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    ))}
                </Col>
               </Row>
               
            
            </Col>
          </Row>
       
      
                
        </Col>
        
        </Row>

     </>
    )
  }
  
  export default SiteDetails;
